module.exports = __webpack_public_path__ + "img/psg-logo-icon.fbe6404a.png";